<template>
    <PartTransactions></PartTransactions>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PartTransactions = defineAsyncComponent(() =>
    import("../../components/Logistics/PartTransactions.vue")
);
export default {
    name: "PM_PartTransactions", //The name you are in should not equal the name of the component you are importing.
    components: { PartTransactions, AuthLayout },
};
</script>